import type { FetcherAxiosInstance } from '../fetcher';

export const createSeoApi = (Fetcher: FetcherAxiosInstance) => ({
  fetchSeo(url: string) {
    return Fetcher.get('/seo', { params: { url } });
  },
});
